// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root___j8XJ","range":"MonthRangeSwitch_range__qmruB","disabled":"MonthRangeSwitch_disabled__1DYh0"};